import(/* webpackMode: "eager" */ "/home/runner/work/build-a-dress/build-a-dress/node_modules/next/dist/client/app-dir/link.js");
